import React from 'react';
import { ShieldCheck, Clock, Lock, Zap, FileText } from 'lucide-react';
import { Button } from './ui';
import { trackInitiateCheckout } from './useMetaPixel';
import { useCountdown } from '../hooks/useCountdown';
import { CHECKOUT_URL, costs, finalPath, prices } from '../data/kit';
export function CostOfInaction() {
  const {
    units
  } = useCountdown({
    h: 23,
    m: 58,
    s: 59
  });
  return <section className="py-12 px-3 sm:px-4 bg-white" data-id="element-35" data-mp="34w9tbcl7yxvg">
      <div className="max-w-5xl mx-auto mb-12" data-id="element-36" data-mp="34vi7gthfceid">
        <h2 className="font-serif text-xl sm:text-2xl md:text-3xl font-bold text-wine text-center mb-5" data-id="element-37" data-mp="38xd77tjpiju1">
          ⚖️ ¿CUÁNTO TE CUESTA SEGUIR SIN UN CAMINO CLARO?
        </h2>
        <div className="rounded-2xl border border-cream-400 overflow-hidden" data-id="element-38" data-mp="3dqo9dhdkqcfm">
          <table className="w-full text-left border-collapse table-fixed" data-id="element-39" data-mp="3imn03bmdk6j7">
            <colgroup data-id="element-40" data-mp="3nnsurezli3vd">
              <col className="w-[48%]" data-id="element-41" data-mp="3nocbwthf8o8c" />
              <col className="w-[52%]" data-id="element-42" data-mp="3sl2txmcsdtwe" />
            </colgroup>
            <thead data-id="element-43" data-mp="3sji0k027kh04">
              <tr className="bg-cream-100 border-b border-cream-400" data-id="element-44" data-mp="3eggbabr9tyvo">
                <th className="px-3 sm:px-5 py-2.5 text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-ink-soft" data-id="element-45" data-mp="3ehrbk1licoi1">
                  Sin un recorrido claro
                </th>
                <th className="px-3 sm:px-5 py-2.5 text-[11px] sm:text-xs font-bold uppercase tracking-wider text-rose-700 bg-rose-50" data-id="element-46" data-mp="34ik23phw9e07">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-300" data-id="element-47" data-mp="13e8pl8o7z83">
              {costs.map(([problem, cost]) => <tr key={problem} data-id="element-48" data-mp="3nh4nr210nr6g">
                  <td className="px-3 sm:px-5 py-3 text-[13px] sm:text-base text-ink-muted leading-snug" data-id="element-49" data-mp="3ng3263mdjmah">
                    {problem}
                  </td>
                  <td className="px-3 sm:px-5 py-3 text-[13px] sm:text-base font-semibold text-wine leading-snug bg-rose-50/60" data-id="element-50" data-mp="js1cm0f42ik3">
                    {cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-51" data-mp="299yhyryewz6q">
        <p className="font-serif text-xl md:text-2xl font-bold text-wine" data-id="element-52" data-mp="2e8jccaqzgon9">
          LOS PRÓXIMOS 21 DÍAS PUEDEN SER DIFERENTES.
        </p>
        <p className="font-serif text-xl md:text-2xl font-bold text-rose-600 mt-1 max-w-2xl mx-auto" data-id="element-53" data-mp="1zj3nx1excvaq">
          Esta vez no necesitás abrir internet y preguntarte qué ejercicio hacer.
        </p>
        <p className="text-base md:text-lg text-ink-muted mt-3" data-id="element-54" data-mp="1qhdwvwoyfydh">
          Vas a tener un recorrido claro frente a vos.
        </p>
        <p className="text-[13px] sm:text-sm font-semibold text-rose-700 mt-2" data-id="element-55" data-mp="1gkj0pkg5ma2d">
          {finalPath.join(' · ')}
        </p>

        <p className="mt-9 flex items-center justify-center gap-2 font-bold text-wine text-base md:text-lg" data-id="element-56" data-mp="1lisvvv1vpanz">
          <Clock className="w-5 h-5 text-rose-500" data-id="element-57" data-mp="3azlkr2mfozxw" />
          EL PRECIO DE LANZAMIENTO CIERRA EN:
        </p>
        <div className="mt-4 flex items-start justify-center gap-3 sm:gap-6" role="timer" data-id="element-58" data-mp="3fwc1ls62bzkd">
          {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-59" data-mp="148719t22xk1v" data-mpi={i}>
              {i > 0 && <span className="font-serif text-rose-300 font-bold text-4xl sm:text-5xl leading-none" aria-hidden="true" data-id="element-60" data-mp="zcrufl2hooey">
                  :
                </span>}
              <div className="text-center" data-id="element-61" data-mp="198bkhqudgsvs">
                <p className="tabular-nums font-serif font-bold text-rose-600 text-5xl sm:text-6xl leading-none" data-id="element-62" data-mp="197jqulkc5585">
                  {String(unit.value).padStart(2, '0')}
                </p>
                <p className="mt-2 text-[11px] font-semibold tracking-[0.3em] text-ink-soft" data-id="element-63" data-mp="1j18ypksbzvol">
                  {unit.label}
                </p>
              </div>
            </React.Fragment>)}
        </div>

        <div className="max-w-md mx-auto mt-8 rounded-3xl border-2 border-rose-400 bg-white p-5 sm:p-6 shadow-[0_24px_55px_-28px_rgba(82,88,121,0.35)]" data-id="element-64" data-mp="2kwlwb2l4lv5">
          <h3 className="font-serif font-bold text-wine text-lg sm:text-xl tracking-tight leading-tight" data-id="element-65" data-mp="3tsisocklp4g8">
            ⭐ SUELO PÉLVICO FUERTE +40
          </h3>
          <p className="text-sm text-rose-600 font-bold mt-1" data-id="element-66" data-mp="41to1y67vd2m">Guía principal + 4 bonos</p>
          <span className="inline-block mt-2 bg-lila-100 text-lila-600 text-[10px] font-extrabold uppercase tracking-[0.16em] px-2.5 py-1 rounded-full" data-id="element-67" data-mp="916gcyfuxccl">
            Oferta de lanzamiento
          </span>
          <p className="text-xs font-bold uppercase tracking-widest text-ink-soft mt-4" data-id="element-68" data-mp="3ci58lvtgc725">
            Antes{' '}
            <span className="text-sm font-semibold tracking-normal text-ink-soft line-through decoration-rose-500 decoration-2" data-id="element-69" data-mp="3hggdrt8sxte1">
              {prices.before}
            </span>
          </p>
          <p className="text-xs font-bold uppercase tracking-widest text-rose-600 mt-3" data-id="element-70" data-mp="3r7b3x8p65d4r">
            Ahora
          </p>
          <p className="font-serif text-[64px] sm:text-[84px] font-bold text-rose-600 leading-none tracking-tight mt-1 tabular-nums" data-id="element-71" data-mp="2tqcefy2ncfsu">
            {prices.now}
          </p>
          <span className="inline-block mt-3 bg-sage-100 text-sage-600 text-[11px] font-extrabold uppercase tracking-wide px-3 py-1 rounded-full" data-id="element-72" data-mp="1fv3z5z0xq1ee">
            Ahorrás {prices.saving}
          </span>
          <p className="text-xs text-ink-muted mt-3" data-id="element-73" data-mp="16ufmb7na2733">✓ Pago único · ⚡ Acceso inmediato</p>
          <Button className="w-full mt-4 text-base py-4" onClick={() => {
          trackInitiateCheckout();
          window.location.href = CHECKOUT_URL;
        }} data-id="element-74" data-mp="11vl1k05r28gc">
            → QUIERO ACCEDER A SUELO PÉLVICO FUERTE +40
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-ink-muted mt-6" data-id="element-75" data-mp="o3y80836ze19">
          <span className="flex items-center" data-id="element-76" data-mp="j5d520wk2g94">
            <Lock className="w-4 h-4 mr-1 text-ink-soft" data-id="element-77" data-mp="j6o8u0q03o08" /> Pago seguro
          </span>
          <span className="flex items-center" data-id="element-78" data-mp="e4p4oomfsn28">
            <Zap className="w-4 h-4 mr-1 text-rose-500" data-id="element-79" data-mp="e7uy2g23mb3r" /> Acceso inmediato
          </span>
          <span className="flex items-center" data-id="element-80" data-mp="999ss27zp18g">
            <ShieldCheck className="w-4 h-4 mr-1 text-sage-600" data-id="element-81" data-mp="3vnnzpmiknfyq" /> Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-82" data-mp="4io5y067u539">
            <FileText className="w-4 h-4 mr-1 text-rose-500" data-id="element-83" data-mp="4gbk3bxc7akx" /> Material digital
          </span>
        </div>
      </div>
    </section>;
}